import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DateRangePicker } from 'react-dates';
import { ReactComponent as Edit } from 'Icons/edit.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import Moment from 'moment';
import Sticky from 'Components/Sticky';
import Heading from 'Components/Heading';
import SubHeading from 'Components/SubHeading';
import Dropdown from 'Components/Dropdown';
import ActionLoader from 'Components/ActionLoader';
import { getCookie, getUser } from 'Utils/storage';
import Upload from 'Components/Upload';
import EditPopup from './editContract';
import Overlay from 'Components/Overlay';
import Input from "Components/Input";
import Cx from 'classnames';
import { GET_TRANSPORTERS_LIST,
        DOWNLOAD_MULTI_CONTRACT_TEMP,
        UPLOAD_MULTI_CONTRACT,
        GET_MULTI_CONTRACT_DETAILS,
        DELETE_MULTI_CONTRACT,
        GET_VEHICLE_TYPES,
        GET_VEHICLE_BODY_TYPES,
        GET_PRICING_BASIS,
        GET_BUSINESS_VOLUMES,
        GET_MULTI_CONTRACT_TYPES,
        GET_TRIP_TYPES,
        UPDATE_MULTI_CONTRACT,
        MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL,
        APPROVE_MULTI_CONTRACT,
        REJECT_MULTI_CONTRACT,
        GET_SERVICE_MODE_TYPES_LIST
    } from 'Constants/actionConstants';
import { ABFRL } from 'Constants/commonConstants';

class MultiContract extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
          
            selected: [],
            isChecked: false,
            transporterName: '',
            transporterId: '',
            openEdit: false,
            startDate: '',
            endDate: '',
            contract_status: 1
        }
    }
     
    componentDidMount() {
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
        const branchId = tegUser.branchId;
        dispatch({
            type: GET_TRANSPORTERS_LIST,
            params: {
                companyId,
                branchId
            }
        });
        this.getMultiContractDetails();
        this.getConstansValues();
        this.handleGetServiceModeTypesList();
    }

    componentWillReceiveProps(nextProps, props) {
        if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
           this.getConstansValues((nextProps.selectedNavBranch || {}).branch_id);
        }
    }

    getConstansValues = (branchId = '') => {
        const { dispatch } = this.props;
        const user = getUser();
        const params = {
            rfqType: 1,
            companyId: user.companyId,
            branchId: branchId ? branchId : user.branchId
        }
        dispatch({
            type: GET_PRICING_BASIS,
            data: params
        });
        dispatch({ 
            type: GET_VEHICLE_TYPES, 
            params 
        });
        dispatch({
            type: GET_VEHICLE_BODY_TYPES,
            params
        });
        dispatch({ 
            type: GET_BUSINESS_VOLUMES, 
            data: params 
        });
        dispatch({
            type: GET_TRIP_TYPES
        });
        dispatch({
            type: GET_MULTI_CONTRACT_TYPES
        });
    }

    closeEdit = () => {
        this.setState({openEdit: false})
    }

    getMultiContractDetails = () => {
        const { dispatch } = this.props;
        const { transporterId, startDate, endDate, contract_status,contractType,source,destination } = this.state;
        dispatch({
            type: GET_MULTI_CONTRACT_DETAILS,
            params: {
                offset: 0,
                limit: 10,
                transporterId,
                contract_status,
                contractType,
                from: startDate ? Moment(startDate).valueOf() : '',
                to: endDate ? Moment(endDate).valueOf() : '',
                source,
                destination
            }
        });
    }

    deleteContract = (tripId) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_MULTI_CONTRACT,
            data: {
                tripId
            },
            onSuccess: () => {
                this.getMultiContractDetails()
            }
        })
    }

    uploadFile = (file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_MULTI_CONTRACT,
            file,
            params: {
                ipAddress: localStorage.getItem('IPAddress')
            },
            onSuccess: () => {
                this.getMultiContractDetails()
            }
        });
    }

    downloadtemplate = (type) => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_MULTI_CONTRACT_TEMP,
            params: {
                type 
            }
        });
    }

    updateContract = (data) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPDATE_MULTI_CONTRACT,
            data,
            onSuccess: () => {
                this.setState({openEdit: false}, this.getMultiContractDetails)
            }
        });
    }

    navigate = () => {
        window.location.href = "/seeker";
    }
   
    handleHeaderCheckboxChange = () => {
        const { isChecked } = this.state;
        const { multiContracts } = this.props;
        if (!isChecked) {
            this.setState({ selected: [...(multiContracts || {}).contract] });
        } else {
            this.setState({ selected: [] });
        }
        this.setState({ isChecked: !isChecked });
    };
      
      
    handleChange = (selectedContract) => {
        const { selected, isChecked } = this.state;
        const index = selected.findIndex((contract) => contract.trip_id === selectedContract.trip_id);

        if (index === -1) {
            const selectedData = selectedContract;
            selected.push(selectedData);
        } else {
            selected.splice(index, 1);
        }

        const allSelected = selected.length === this.props.multiContracts.length;
        if (allSelected !== isChecked) {
            this.setState({ isChecked: allSelected });
        }

        this.setState({ selected });
    };
      
      
    handleButtonClick = (status) => {
        this.setState({ contract_status: status},this.getMultiContractDetails);
    } 

    sendLOIForApproval = (loiApprover) => {
        const { selected, rejectRemarks } = this.state;
        const { dispatch } = this.props;
        const data = {
                "rfq_id": '',
                "rfqType": 1,
                "loi_approve_type": loiApprover,
                "loi_list": (selected || []).map(trip => {
                    return { 
                        "trip_id": trip.trip_id,
                        "transporter_id": trip.transporter_id
                }})
            }
        if(loiApprover == 4){
            data['appover_rejected_remarks'] = rejectRemarks;
        }
        const API = (loiApprover == 3 ? APPROVE_MULTI_CONTRACT : (loiApprover == 4 ? REJECT_MULTI_CONTRACT : MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL))
        dispatch({
            type: API,
            data,
            onSuccess: () => {
                this.setState({
                    selected: [],
                    isChecked: false,
                    rejectPopup: false
                });
                this.getMultiContractDetails();
            }
        })
    }


    getContractStatus = (id) => {
        let sFlag = 'New';
        if(id === 2) {
            sFlag = 'Pending'
        } else if(id === 3) {
            sFlag = 'Approved'
        } else if(id === 4) {
            sFlag = 'Rejected'
        }
        return sFlag;
    }

    handleGetServiceModeTypesList = () => {
        const { dispatch } = this.props;
        const type = 0;
        const queryParams = {
          type,
        };
        dispatch({
          type: GET_SERVICE_MODE_TYPES_LIST,
          queryParams,
        });
      };

      onCancelFilter = (name) => {
        if(name==='destination'){
            this.setState({ destination: '' }, this.getMultiContractDetails);
        }
        if(name==='source'){
            this.setState({ source: '' }, this.getMultiContractDetails);
        }

        this.setState({ 
            source: '', 
            destination: '', 
            transporterName:'',
            transporterId:'',
            contractType:'',
            endDate:'',
            from:'',
            to:'',
            startDate:''}, this.getMultiContractDetails);
    }

    render(){
        const { 
            rfqs, 
            transporters, 
            multiContracts, 
            loader, 
            companyBranchDetails, 
            pricingBasis,
            serviceModeTypesList,
            multiContractTypes
        } = this.props;
        console.log('multiContractTypes:', multiContractTypes)
        const { offset, limit, startDate, endDate, contract_status,destination,source } = this.state;
        const { isChecked, selected } = this.state;
        const user = getUser();
        return (
            <Sticky>
                {loader && <ActionLoader fixed={true} />}
                <div className="pl-20 pr-20 pt-20 pb-20 mc-bg">
                    <div className='flex'>
                        <svg width="106" height="36" viewBox="0 0 106 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M56.728 17.432C57.624 17.592 58.384 18.064 59.008 18.848C59.632 19.632 59.944 20.52 59.944 21.512C59.944 22.36 59.72 23.128 59.272 23.816C58.84 24.488 58.208 25.024 57.376 25.424C56.544 25.808 55.576 26 54.472 26H47.8V9.32H54.16C55.296 9.32 56.272 9.512 57.088 9.896C57.904 10.28 58.52 10.8 58.936 11.456C59.352 12.096 59.56 12.816 59.56 13.616C59.56 14.576 59.304 15.376 58.792 16.016C58.28 16.656 57.592 17.128 56.728 17.432ZM50.536 16.328H53.92C54.816 16.328 55.512 16.128 56.008 15.728C56.52 15.312 56.776 14.72 56.776 13.952C56.776 13.2 56.52 12.616 56.008 12.2C55.512 11.768 54.816 11.552 53.92 11.552H50.536V16.328ZM54.232 23.768C55.16 23.768 55.888 23.544 56.416 23.096C56.944 22.648 57.208 22.024 57.208 21.224C57.208 20.408 56.928 19.76 56.368 19.28C55.808 18.8 55.064 18.56 54.136 18.56H50.536V23.768H54.232ZM62.0052 19.328C62.0052 18 62.2772 16.824 62.8212 15.8C63.3812 14.776 64.1332 13.984 65.0772 13.424C66.0372 12.848 67.0932 12.56 68.2452 12.56C69.2852 12.56 70.1892 12.768 70.9572 13.184C71.7412 13.584 72.3652 14.088 72.8292 14.696V12.776H75.5892V26H72.8292V24.032C72.3652 24.656 71.7332 25.176 70.9332 25.592C70.1332 26.008 69.2212 26.216 68.1972 26.216C67.0612 26.216 66.0212 25.928 65.0772 25.352C64.1332 24.76 63.3812 23.944 62.8212 22.904C62.2772 21.848 62.0052 20.656 62.0052 19.328ZM72.8292 19.376C72.8292 18.464 72.6372 17.672 72.2532 17C71.8852 16.328 71.3972 15.816 70.7892 15.464C70.1812 15.112 69.5252 14.936 68.8212 14.936C68.1172 14.936 67.4612 15.112 66.8532 15.464C66.2452 15.8 65.7492 16.304 65.3652 16.976C64.9972 17.632 64.8132 18.416 64.8132 19.328C64.8132 20.24 64.9972 21.04 65.3652 21.728C65.7492 22.416 66.2452 22.944 66.8532 23.312C67.4772 23.664 68.1332 23.84 68.8212 23.84C69.5252 23.84 70.1812 23.664 70.7892 23.312C71.3972 22.96 71.8852 22.448 72.2532 21.776C72.6372 21.088 72.8292 20.288 72.8292 19.376ZM78.2708 19.376C78.2708 18.016 78.5428 16.824 79.0868 15.8C79.6468 14.76 80.4148 13.96 81.3908 13.4C82.3668 12.84 83.4868 12.56 84.7508 12.56C86.3508 12.56 87.6708 12.944 88.7108 13.712C89.7668 14.464 90.4788 15.544 90.8468 16.952H87.8948C87.6548 16.296 87.2708 15.784 86.7428 15.416C86.2148 15.048 85.5508 14.864 84.7508 14.864C83.6308 14.864 82.7348 15.264 82.0628 16.064C81.4068 16.848 81.0788 17.952 81.0788 19.376C81.0788 20.8 81.4068 21.912 82.0628 22.712C82.7348 23.512 83.6308 23.912 84.7508 23.912C86.3348 23.912 87.3828 23.216 87.8948 21.824H90.8468C90.4628 23.168 89.7428 24.24 88.6868 25.04C87.6308 25.824 86.3188 26.216 84.7508 26.216C83.4868 26.216 82.3668 25.936 81.3908 25.376C80.4148 24.8 79.6468 24 79.0868 22.976C78.5428 21.936 78.2708 20.736 78.2708 19.376ZM98.8054 19.4L104.901 26H101.205L96.3094 20.312V26H93.5734V8.24H96.3094V18.56L101.109 12.776H104.901L98.8054 19.4Z" fill="#627FE9"/>
                            <path d="M31.5 16.5H10.245L15.615 11.115L13.5 9L4.5 18L13.5 27L15.615 24.87L10.245 19.5H31.5V16.5Z" fill="#627FE9" onClick={this.navigate}/>
                        </svg>
                        <div className='heading-div'>
                            <Heading text="Multi Contracts" className=' ml-20 mt-2 heading' />
                        </div>
                    </div>
                   
                    <div className="flex flex-wrap mb-50 pr-10 mt-30 d-block text-center">
                        <div className='transporters-contractdate-container'>

                            <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                                <SubHeading text="Transporter" className="mb-10 text-center " />
                                <Dropdown
                                    items={transporters}
                                    selectedItem={transporters.find(transporter => {return this.state.transporterName === transporter.name})}
                                    displayKey="name"
                                    name="transporter"
                                    label="Select Transporter"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search Transporter'}
                                    onSelect={(value) => {
                                        this.setState({transporterName: value.name, transporterId: value.id}, this.getMultiContractDetails)
                                        }
                                    }
                                    className="text-center wt-250 transporter-select"
                                    canClear={true}
                                />
                            </div>

                            <div className="wt-300 mt-5 ml-5 mb-10 w-inherit text-center">
                                <SubHeading text="Contract Date" className="mb-10" />
                                <div className="mb-10 pr-10 multiContract">
                                    <DateRangePicker
                                        startDate={startDate ? Moment(startDate) : null}
                                        startDateId="startDate"
                                        endDate={endDate ? Moment(endDate) : null}
                                        endDateId="endDate"
                                        onDatesChange={({ startDate, endDate }) => {
                                            const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
                                            const endDateTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                            this.setState({startDate: startDateTime, endDate: endDateTime}, () => this.getMultiContractDetails());
                                        }}
                                        focusedInput={this.state.focusedInput}
                                        onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                        displayFormat={'DD MMM YYYY'}
                                        noBorder={true}
                                        minimumNights={0}
                                        isOutsideRange={() => false}
                                        className={'pr-10'}
                                        showClearDates={true}
                                    />
                                </div>
                            </div>

                            {ABFRL.includes(user.companyId)&&
                            <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                                <SubHeading text="Contract Type" className="mb-10 text-center " />
                                <Dropdown
                                    items={multiContractTypes}
                                    selectedItem={multiContractTypes.find(contractType => {return this.state.contractType === contractType.id})}
                                    displayKey="name"
                                    name="Contract Type"
                                    label="Select Contract Type"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search Contract'}
                                    onSelect={(value) => {
                                        this.setState({contractType: value.id}, this.getMultiContractDetails)
                                        }
                                    }
                                    className="text-center wt-250 transporter-select"
                                    canClear={true}
                                />
                            </div>}

                            {ABFRL.includes(user.companyId)&&
                            <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                                <SubHeading text="Search Locations" className="mb-10 text-center " />
                                <div className="mr-10 flex border-theme br-5 fBold bg-white wt-max-content ">
                                    <span className="pr">
                                        <input placeholder={"Source"}
                                        type="text" 
                                        className="br-5 ht-40 fs-14 fBold tCenter "
                                        value={source}
                                        name="source"
                                        onChange={(e) => {
                                            this.setState({source: e.target.value},  this.getMultiContractDetails)
                                        }}
                                        />
                                        {(source || '').length > 0 && 
                                            <span 
                                                className="clearable__clear" 
                                                onClick={() => this.onCancelFilter('source')}
                                            >&times;</span>}
                                    </span>
                                    <span className="mt-10">{"-"}</span>
                                    <span className="pr">
                                        <input placeholder={"Destination"}
                                        type="text" 
                                        className="br-5 ht-40 fBold fs-14 tCenter"
                                        value={destination}
                                        name="destination"
                                        onChange={(e) => {
                                            this.setState({destination: e.target.value},  this.getMultiContractDetails)
                                        }}
                                        />
                                        {(destination || '').length > 0 && 
                                            <span 
                                                className="clearable__clear" 
                                                onClick={() => this.onCancelFilter('destination')}
                                            >&times;</span>}
                                    </span>
                                </div>
                            </div>}
                            {ABFRL.includes(user.companyId)&&
                                <div className="wt-250 mt-35 ml-50 mb-2 mr-20 w-inherit text-center">
                                <div className="view-details-button" onClick={(e) => this.onCancelFilter(e)}>
                                    <button className="br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 print-trips-button curP ht-40 ml-10">Clear Filters</button>
                                </div>
                            </div>}
                            

                        </div>
                        <div className='btn-field flex flex-between'>
                            <div className='navtab'>
                                <button className='nav-new nav-btns' onClick={() => this.handleButtonClick(1)}  style={{ backgroundColor:    contract_status=== 1 ? '#528aea' : 'white', color: contract_status === 1 ? 'white' : '#528aea' }}>{`New (${multiContracts.new_count || 0})`}</button>
                                <button className='nav-pending nav-btns'onClick={() => this.handleButtonClick(2)} style={{ backgroundColor:  contract_status === 2 ? '#528aea' : 'white', color: contract_status === 2 ? 'white' : '#528aea' }}>{`Pending (${multiContracts.pending_count || 0})`}</button>
                                <button className='nav-approved nav-btns'onClick={() => this.handleButtonClick(3)} style={{ backgroundColor: contract_status === 3 ? '#528aea' : 'white', color: contract_status === 3 ? 'white' : '#528aea' }}>{`Approved (${multiContracts.approved_count || 0})`}</button>
                                <button className='nav-rejected nav-btns'onClick={() => this.handleButtonClick(4)} style={{ backgroundColor: contract_status === 4 ? '#528aea' : 'white', color: contract_status === 4 ? 'white' : '#528aea' }}>{`Rejected (${multiContracts.reject_count || 0})`}</button>
                            </div>
                                    
                            <div className='flex fRight ul-dl-sa'>
                                {!user.isApprover &&
                                <>
                                <button className="br-4  fs-16 fBold pl-30 pr-30 mr-10 ul-dl-btns dl-t curP ht-40 ml-10 mt-30" onClick={() => this.downloadtemplate(1)}>Template  
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.16665 16.6667H15.8333V15H4.16665M15.8333 7.5H12.5V2.5H7.49998V7.5H4.16665L9.99998 13.3333L15.8333 7.5Z" fill="#627FE9"/>
                                    </svg>
                                </button>
                                <Upload onChange={this.uploadFile} className="mt-30">
                                    <button className="br-4  fs-15 fBold pl-30 pr-30 mr-10 ul-dl-btns ul-t curP ht-40 ml-10">Upload Template 
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.49999 13.3333V8.33333H4.16666L9.99999 2.5L15.8333 8.33333H12.5V13.3333H7.49999ZM4.16666 16.6667V15H15.8333V16.6667H4.16666Z" fill="#627FE9"/>
                                        </svg>
                                    </button>
                                </Upload>                                  
                                <button className="br-4  fs-15 fBold pl-30 pr-30 mr-10 ul-dl-btns dl-d curP ht-40 ml-10 mt-30" onClick={() => this.downloadtemplate(2)}>Download Data</button>
                                </>}
                                {([1,4].includes(contract_status) && !user.isApprover) && (
                                        <button
                                            className={Cx("br-4 fs-16 fBold pl-30 pr-30 mr-10 sfa curP ht-40 ml-10 mt-30", {
                                                'notselectable': selected.length === 0
                                            })}
                                            onClick={() => this.sendLOIForApproval(1)}
                                        >
                                            Send for Approval
                                        </button>
                                    )}
                                {([2].includes(contract_status)) && user.isApprover &&
                                    <>
                                        <button
                                            className={Cx("br-4 fs-16 fBold pl-30 pr-30 mr-10 sfa curP ht-40 ml-10 mt-30", {
                                                'notselectable': selected.length === 0
                                            })}
                                            onClick={() => this.sendLOIForApproval(3)}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            className={Cx("br-4  fs-16 fBold pl-30 pr-30 mr-10 ul-dl-btns dl-t curP ht-40 ml-10 mt-30", {
                                                'notselectable': selected.length === 0
                                            })}
                                            onClick={() => this.setState({rejectPopup: true})}
                                        >
                                            Reject
                                        </button>
                                    </>
                                }
                                {/* <button className={Cx("br-4  fs-16 fBold pl-30 pr-30 mr-10 sfa curP ht-40 ml-10 mt-30", {
                                    'notselectable': selected.length === 0
                                })} onClick={this.sendLOIForApproval}>Send for Approval</button>    */}
                            </div>
                        </div> 
                    </div>
                    <div className="flex-1 flex-column ht-1000  br-5 m-10 table-parent-div">
                        <table style={{borderSpacing: '0px'}} className='mc-table'>
                            <thead>
                                {[1, 2, 4].includes(contract_status) ? (<th className='p-5 bg-dark-blue white-color border-light'>   
                                    <input
                                        type="checkbox"
                                        onChange={this.handleHeaderCheckboxChange}
                                        checked={isChecked}
                                    />
                                </th>):null}
                                {ABFRL.includes(user.companyId) && <th className='p-5 bg-dark-blue white-color border-light'>Route Name/Code</th>}
                                {ABFRL.includes(user.companyId) && <th className='p-5 bg-dark-blue white-color border-light'>Route City</th>}
                                <th className='p-5 bg-dark-blue white-color border-light'>Contract Type</th>
                                {ABFRL.includes(user.companyId) && <th className='p-5 bg-dark-blue white-color border-light'>Mode Type</th>}
                                {ABFRL.includes(user.companyId) && <th className='p-5 bg-dark-blue white-color border-light'>Leg </th>}
                                <th className='p-5 bg-dark-blue white-color border-light'>Source City </th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Destination City </th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Vehicle Type</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Body Type</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Pricing Basis</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Min. KM</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Per KM if Exceed</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Trip Type</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Total Trip KM</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Google Distance (KM)</th>
                               {!ABFRL.includes(user.companyId) && <th className='p-5 bg-dark-blue white-color border-light'>Route Name/Code</th>}
                                <th className='p-5 bg-dark-blue white-color border-light'>Rate</th>
                                <th className='p-5 bg-dark-blue white-color border-light'>Transporter Name</th>
                                <th className='p-5 bg-dark-blue white-color border-light wt-10p'>Contract Date</th>
                                {(contract_status !== 1) && (
                                    <th className='p-5 bg-dark-blue white-color border-light'>Status</th>
                                )}
                                {(contract_status == 4) && (
                                    <th className='p-5 bg-dark-blue white-color border-light'>Remarks</th>
                                )}

                                {/* <th className='p-5 bg-dark-blue white-color border-light'>Status</th> */}
                                {[1, 3, 4].includes(contract_status) && (contract_status == 3 ? !user.isApprover : true) &&(ABFRL.includes(user.companyId) ? !user.isApprover:true) && <th className='p-5 bg-dark-blue white-color border-light'>Action</th>}
                            </thead>
                            <tbody>
                                
                                {((multiContracts || {}).contract || []).map((contract, index) => {
                                    const destinationIndex = (contract.stops || []).length - 1;
                                    const isApprovedOrRejected = ((contract.contract_approver_status || []).find(app => app.contract_approver_email.includes(user.email)))
                                    
                                    return(
                                        <tr key={index}>
                                            {([1, 4].includes(contract_status) || (contract_status == 2 && isApprovedOrRejected && [1,2].includes(isApprovedOrRejected.contract_status))) ? (
                                                <td className='p-10 border-light tCenter fs-15'>
                                                    <input
                                                        type="checkbox"
                                                        onChange={() => this.handleChange(contract)}
                                                        checked={selected.some((selectedContract) => selectedContract.trip_id === contract.trip_id)}
                                                    />
                                                </td>
                                            ) : ([2].includes(contract_status) ? <td></td> : null)}

                                           {/* <td className='p-10 border-light tCenter fs-15'>
                                                <input
                                                    type="checkbox"
                                                    onChange={() => this.handleChange(contract)}
                                                    checked={selected.some((selectedContract) => selectedContract.trip_id === contract.trip_id)}
                                                />
                                            </td> */}
                                            {ABFRL.includes(user.companyId) && <td className='p-10 border-light tCenter fs-15'>{contract.route_code}</td>}
                                            {ABFRL.includes(user.companyId) && <td className='p-10 border-light tCenter fs-15'>{contract.route_city}</td>}
                                            <td className='p-10 border-light tCenter fs-15'>{contract.contract_type_name}</td>
                                            {ABFRL.includes(user.companyId) && <td className='p-10 border-light tCenter fs-15'>{contract.service_mode_name}</td>}
                                            {ABFRL.includes(user.companyId) && <td className='p-10 border-light tCenter fs-15'>{contract.leg_sequence}</td>}
                                            <td className='p-10 border-light tCenter fs-15'>{(contract.stops || [])[0].city + ' - ' + (contract.stops || [])[0].state }</td>
                                            <td className='p-10 border-light tCenter fs-15'>{(contract.stops || [])[destinationIndex].city + ' - ' + (contract.stops || [])[destinationIndex].state }</td>
                                            <td className='p-10 border-light tCenter fs-15'>{(contract.vehicle_details || {}).vehicle_type_name}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{(contract.vehicle_details || {}).vehicle_body_type_name}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.pricing_basis_name}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.minimum_km}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.exceed_per_km}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.contract_trip_name}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.totalKm}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.distance}</td>
                                            {!ABFRL.includes(user.companyId) &&<td className='p-10 border-light tCenter fs-15'>{contract.route_code}</td>}
                                            <td className='p-10 border-light tCenter fs-15'>{contract.price}</td>
                                            <td className='p-10 border-light tCenter fs-15'>{contract.transporter_name}</td>
                                            
                                            <td className='p-10 border-light tCenter fs-15'>
                                                <div className='mb-5'><span className='fBold'>From: </span>{contract.trip_contract_tenure_from ? Moment(contract.trip_contract_tenure_from).format('DD/MM/YYYY') : ''}</div>
                                                <div><span className='fBold'>To: </span>{contract.trip_contract_tenure_to ? Moment(contract.trip_contract_tenure_to).format('DD/MM/YYYY') : ''}</div>
                                                <div>{(contract.trip_contract_tenure_to && contract.trip_contract_tenure_to > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : <span className='fs-14 fBold error-color'> Expired </span>}</div>
                                            </td>
                                            {(contract_status !== 1) && (
                                                <td className='p-10 border-light tCenter fs-15'>
                                                    {(contract.contract_approver_status || []).map(el => {
                                                        const approverName = ((contract.approver_names || []).find(approver => (el.contract_approver_email || []).includes(approver.email)) || {}).user_name || '';
                                                        return (
                                                            <div>
                                                                <span>{approverName}</span> / <span className='theme-color'>{el.contract_approver_level}</span> / <span>{this.getContractStatus(el.contract_status)}</span> / <span>{el.contract_approver_time && Moment(el.contract_approver_time).format('DD/MM/YYYY hh:mm a')}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </td>
                                            )}
                                            {(contract_status == 4) &&
                                                <td className='p-10 border-light tCenter fs-15'>{contract.appover_rejected_remarks || '-'}</td>
                                            }
                                            {/* <td className='p-10 border-light tCenter fs-15'>{(contract.contract_approver_status || []).map(el => {
                                                const approverName = ((contract.approver_names || []).find(approver => (el.contract_approver_email || []).includes(approver.email)) || {}).user_name || ''
                                                return <div><span>{approverName}</span> / <span className='theme-color'>{el.contract_approver_level}</span> / <span>{this.getContractStatus(el.contract_status)}</span></div>
                                            })}</td> */}
                                            {[1, 3, 4].includes(contract_status) && (contract_status == 3 ? !user.isApprover : true) && (ABFRL.includes(user.companyId) ? !user.isApprover:true) && <td className='p-10 border-light tCenter fs-15'>
                                                {(contract_status == 3 ? !user.isApprover : true) && <Edit className="ht-15 wt-15 ml-5 curP mb-5" onClick={() => this.setState({openEdit: true, selectedContract: contract})}/>}
                                                {![3].includes(contract_status) && <DeleteIcon className="ht-15 wt-15 ml-5 curP" onClick={() => this.deleteContract(contract.trip_id)}/>}
                                            </td>}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    {this.state.rejectPopup &&
                        <div className="multicontract-reject">
                        <Overlay>
                            <div className="table-row box-shadow ph-20 pv-20 br-100 pr-40 wt-400">
                                <div className="mb-20 tleft theme-color border-bottom-light-2 pb-10 fSemibold fs-18">Reject Contract
                                <span className="pr-10 fRight curP" id='close' onClick={() => this.setState({rejectPopup: false})}>x</span> 
                                </div>
                                
                                <div className="flex flex-wrap mb-20 pr-10 mt-20 d-block text-center">
                                    <div className="wt-250 mt-5 ml-5 mb-2 mr-20 w-inherit text-center">
                                        <textarea
                                            value={this.state.rejectRemarks}
                                            onChange={(e) => {
                                                this.setState({rejectRemarks: e.target.value})
                                                }
                                            }
                                            placeholder="Enter Remarks"
                                            className={'inBlock wt-320 pr-5 ht-80'}
                                            readOnly={false}
                                        />
                                    </div>
                                </div>
                                
                                <div className="flex flex-wrap mb-20 pr-10 mt-10 d-block text-center">
                                    <button
                                        className={Cx("br-4 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-10 sfa curP ht-40 ml-10 mt-10", {
                                            'notselectable': !this.state.rejectRemarks
                                        })}
                                        onClick={() => this.sendLOIForApproval(4)}
                                    >
                                        Reject
                                    </button>
                                    <button
                                        className={Cx("br-4 border-theme fs-16 theme-color fBold pl-30 pr-30 mr-10 ul-dl-btns dl-t curP ht-40 ml-10 mt-10")}
                                        onClick={() => this.setState({rejectPopup: false})}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                
                            </div>
                        </Overlay>
                        </div>
                    }
                    {this.state.openEdit &&
                    <EditPopup 
                        selectedContract = {this.state.selectedContract}
                        closeEdit = {this.closeEdit}
                        transporters = {this.props.transporters}
                        vehicleTypes = {this.props.vehicleTypes}
                        vehicleBodyTypes = {this.props.vehicleBodyTypes}
                        pricingBasis = {this.props.pricingBasis}
                        multiContractTypes = {this.props.multiContractTypes}
                        multiTripTypes = {this.props.multiTripTypes}
                        updateContract = {this.updateContract}
                        contract_status = {contract_status}
                        serviceModeTypesList={serviceModeTypesList}
                    />}
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ constants, contracting,supplierRFQCreateOrUpdateRequest}) => {
    return {
        multiContracts: (contracting.multiContracts || {}).data || {},
        transporters: constants.transportersList || [],
        loader: (contracting.multiContracts || {}).dataLoading || contracting.loader,
        companyBranchDetails: constants.companyBranchDetails || [],
        pricingBasis: constants.pricingBasis || [],
        vehicleTypes: constants.vehicleTypes || [],
        vehicleBodyTypes: constants.vehicleBodyTypes || [],
        multiContractTypes: constants.multiContractTypes || [],
        multiTripTypes: constants.multiTripTypes || [],        
        serviceModeTypesList:
        supplierRFQCreateOrUpdateRequest.serviceModeTypesList || [],
    };
};

export default connect(mapStateToProps)(MultiContract);